app.service('leaseLink', function (productCardConfig, modal, loading) {
	var config, loadingScript = false, loadedScript = false;
	var $modal;

	function htmlEntities(str) {
		return String(str).replace(/&/g, '&').replace(/</g, '<').replace(/>/g, '>').replace(/"/g, '”').replace(/(\r\n\t|\n|\r\t)/gm, "");
	}
	function open() {
		if (loadedScript) {
			loading.start();
			var requestItems = []
			var LeaseLinkClient = new LeaseLinkLib({
				apiKey: config.leaseLinkApiKey
			});
			requestItems.push(LeaseLinkClient.buildApiRequestItem(htmlEntities(config.title), config.price, 1, htmlEntities(config.category)));

			var request = LeaseLinkClient.buildApiRequest(
				document.location.host,
				"00000",
				requestItems
			);
			LeaseLinkClient.requestCalculation(request, function (data, error) {
				loading.stop();
				if (error) {
					modal.alert('Błąd wyliczenia opłaty leasingowej');
				} else {
					const gross = data.FinancialOperationTypeName == 'Loan'; //wartosc brutto
					const totalPayment = gross ? data.TotalPaymentsGrossValue : data.TotalPaymentsValue;
					const closingPaymentValue = totalPayment * 100 * (data.ClosingPaymentPct * 0.01);
					$('#leaselink-rate-value').text(((gross ? data.MonthlyRateGrossValue : data.MonthlyRateNetValue).toFixed(2)).replace(/\./g,',') + ' zł');
					$('#leaselink-duration').text(data.NumberOfRates);
					$('#leaselink-entry-payment-percent').text(' ' + data.EntryPaymentPct  + '%:');
					$('#leaselink-total-payment-value').text(((totalPayment).toFixed(2)).replace(/\./g,',') + ' zł');
					$('#leaselink-closing-payment-percent').text(' ' + data.ClosingPaymentPct + '%:');
					$('#leaselink-closing-payment-value').text(closingPaymentValue == 0 ? closingPaymentValue : closingPaymentValue.toFixed(2).replace(/\./g,',') + ' zł');
					$('#leaselink-calculation-button').attr('href', data.CalulationUrl);
					$('#modal-leaselink-modal').addClass(gross ? 'leaselink-gross' : 'leaselink-net');
					modal.open('leaselink-modal');
				}
			});
		} else if (!loadingScript) {
			loadingScript = true;
			loading.start();
			$.getScript("https://rep.leaselink.pl/plugin/LeaseLinkLib.min.js").done(function () {
				loadedScript = true;
				open();
			}).fail(function () {
				modal.alert('Błąd pobierania danych LeaseLink');
			});
		}
	}
	function init() {
		config = productCardConfig.getData();
		$('body').on('click', '.js-open-leaselink', function () {
			open();
		})
	}
	return {
		init
	}
});
